__turbopack_context__.v({
  "category": "CategoryContainer-module-scss-module__-n8PkG__category",
  "categoryContainer": "CategoryContainer-module-scss-module__-n8PkG__categoryContainer",
  "categoryLink": "CategoryContainer-module-scss-module__-n8PkG__categoryLink",
});
